import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-curtain-angular-five-sided',
  templateUrl: './curtain-angular-five-sided.component.html',
  styleUrls: ['./curtain-angular-five-sided.component.scss']
})
export class CurtainAngularFiveSidedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
